module.exports = __webpack_public_path__ + "img/watch-replies.c20184e3.svg";